/* ============================================================
 * DEINSPAR – Verknüpfte Poster + Set-Rahmen (Option A)
 * Ein gemeinsamer _deinspar_set_id pro Poster/Rahmen-Paar.
 * Aktualisiert Poster UND Set-Rahmen in EINER Shopify Cart-Anfrage.
 * Keine Aktionen für unverbundene Artikel/Einzelrahmen.
 * ============================================================ */
(function () {
  'use strict';

  if (window.DeinsparSetCart) return;

  function cartUrl(action) {
    const base = window.Shopify?.routes?.root || '/';
    return `${base.endsWith('/') ? base : `${base}/`}cart${action ? `/${action}` : ''}.js`;
  }

  async function fetchCart() {
    const response = await fetch(cartUrl(''), {
      method: 'GET', credentials: 'same-origin', headers: { Accept: 'application/json' }
    });
    if (!response.ok) throw new Error('DEINSPAR: Warenkorb konnte nicht geladen werden');
    return response.json();
  }

  async function postCart(action, body) {
    const response = await fetch(cartUrl(action), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        Accept: 'application/json'
      },
      body: JSON.stringify(body)
    });
    if (!response.ok) {
      const bodyText = await response.text();
      throw new Error(`DEINSPAR: Shopify Warenkorb-Fehler (${response.status}): ${bodyText.slice(0, 250)}`);
    }
    return response;
  }

  // Shopify Cart AJAX-API: /cart/update.js akzeptiert LINE-ITEM-KEYS.
  // So bleiben bei zwei gleichen Postern verschiedene Set-IDs getrennt.
  async function performChange(change) {
    const cart = await fetchCart();
    const line = Number(change.line);
    const target = change.id
      ? cart.items.find(item => item.key === String(change.id))
      : (Number.isInteger(line) && line > 0 ? cart.items[line - 1] : undefined);

    // Wenn das Ziel inzwischen aus dem Cart entfernt wurde: keine fremde Position ändern.
    if (!target) {
      throw new Error('DEINSPAR: Warenkorbposition wurde geändert – bitte Seite neu laden');
    }

    const qty = Number(change.quantity);
    if (!Number.isSafeInteger(qty) || qty < 0) {
      throw new Error('DEINSPAR: Ungültige Menge');
    }

    const setId = target.properties?._deinspar_set_id;
    const isPoster = !!setId && target.properties?._deinspar_set_role === 'poster';
    const linkedFrames = isPoster ? cart.items.filter(item =>
      item.properties?._deinspar_set_id === setId &&
      item.properties?._deinspar_set_role === 'frame'
    ) : [];

    const options = {
      sections: change.sections || [],
      sections_url: change.sections_url || window.location.pathname
    };

    if (linkedFrames.length > 0) {
      const updates = { [target.key]: qty };
      linkedFrames.forEach(frame => { updates[frame.key] = qty; });
      // Ein Request für beide Positionen: vermeidet halbfertige Set-Bestellungen.
      return postCart('update', { ...options, updates });
    }

    // Einzelrahmen, einzelne Poster und unabhängig gelöschte Set-Rahmen:
    // normales Shopify-Verhalten, jedoch per eindeutigem Cart-Key.
    return postCart('change', { ...options, id: target.key, quantity: qty });
  }

  // Warteschlange, damit schnell hintereinander ausgeführte Änderungen
  // einander nicht überholen und keinen anderen Artikel treffen.
  let queue = Promise.resolve();
  window.DeinsparSetCart = {
    requestChange(change) {
      const next = queue.then(() => performChange(change));
      queue = next.catch(() => {});
      return next;
    }
  };
})();
